
export default {
    test: 'test2'
}